<template>
  <div class="vehicle-designation">
    <button
      @click.prevent="setVisible"
      class="button button--invert button--solid vehicle-designation__button"
    >
      vælg {{ privateAdFlowProductTypeNames.nameSingularParticular }} manuelt
    </button>
    <div
      class="vehicle-designation__content"
      v-if="visible"
      id="VehicleDesignationContent"
    >
      <div class="step__circle">
        <Arrow direction="down"></Arrow>
      </div>
      <p class="error" v-if="inputError">
        <span>{{ inputError }}</span>
        <span class="error__attention"></span>
      </p>
      <p class="step__section-header">Manuel udpegning</p>
      <div class="vehicle-designation__list">
        <PrivateAdSelect
          class="vehicle-designation__select"
          v-for="(listItem, index) in designationLists"
          :key="listItem.type"
          :title="listItem.title"
          :search-type="listItem.type"
          :index="index"
          :items="listItem.items"
          :event-bus="eventBus"
          :is-disabled="listItem.items.length < 1"
          :type="'radio'"
          :is-initial-load-prop="false"
        ></PrivateAdSelect>
      </div>
    </div>
  </div>
</template>
<script>
import { app } from '@/main'
import Arrow from '@shared/Arrow/Arrow.vue'
import PrivateAdSelect from '../PrivateAdSelect/PrivateAdSelect.vue'
import spinner from '@/spinner'

export default {
  components: {
    Arrow,
    PrivateAdSelect,
  },
  props: {
    eventBus: { default: null, type: Object },
    productTypeId: { default: 0, type: Number },
    initialDesignationLists: { default: null, type: Array },
    visible: { default: false, type: Boolean },
    privateAdFlowProductTypeNames: {
      default: () => {
        return {}
      },
      type: Object,
    },
  },
  data() {
    return {
      designationLists: [],
      searchRequest: [],
      openSelectTitle: '',
      openStack: [],
      inputError: '',
    }
  },
  watch: {
    visible(isVisible) {
      if (!isVisible) {
        this.designationLists = JSON.parse(
          JSON.stringify(this.initialDesignationLists)
        )
      }
    },
  },
  methods: {
    setError(error) {
      this.inputError = error
    },
    setVisible() {
      this.eventBus.emit('private-ad-select-manuel-selection-callback', true)

      // Scroll down to variant manual selection list
      const element = document.getElementById('VehicleDesignationContent')
      if (element == null) return
      element.scrollIntoView({ behavior: 'smooth', block: 'center' })
    },
    toggle(overlayRef) {
      if (overlayRef.isOpen) {
        this.close()
      } else {
        this.open(overlayRef)
      }
    },
    open(overlayRef) {
      app.history.popAll()

      // setTimeout to defeat the race condition in history.back and history.pushState
      window.setTimeout(() => {
        app.history.push(() => {
          const scroll = window.scrollY
          overlayRef.isOpen = false
          // setTimeout to defeat the race condition in history.back and history.pushState
          window.setTimeout(() => {
            window.scrollTo(0, scroll)
          }, 5)
        }, overlayRef)

        overlayRef.isOpen = true
      }, 60)
    },
    close() {
      app.history.pop()
    },
    handleSelection(data) {
      if (data.index < this.designationLists.length - 1) {
        if (data.index < this.initialDesignationLists.length) {
          this.designationLists = this.designationLists.slice(
            0,
            this.initialDesignationLists.length
          )
          const keys = Object.keys(this.initialDesignationLists)
          keys.forEach(key => {
            if (key <= data.index) return
            this.designationLists[key].items = []
          })
        } else {
          this.designationLists = this.designationLists.slice(0, data.index + 1)
        }
      }
      this.searchRequest = this.searchRequest.slice(0, data.index)
      this.searchRequest.push({
        type: data.overlayRef.searchType,
        value: data.item.value,
      })

      this.setError('')
      this.emitVariantList([])
      this.close()
      this.fetchNextStep()
    },
    emitVariantList(variantList) {
      if (this.eventBus === null) return
      this.eventBus.emit('private-ad-select-variant-list', {
        variantList: variantList,
        licensePlate: '',
      })
    },
    fetchNextStep() {
      let method = ''
      let data = {}

      if (this.searchRequest.length == 1) {
        method = 'GetModels'
        data = {
          productTypeId: this.productTypeId,
          makeId: this.searchRequest[0].value,
        }
      } else if (this.searchRequest.length == 2) {
        method = 'GetModelYears'
        data = {
          productTypeId: this.productTypeId,
          modelId: this.searchRequest[1].value,
        }
      } else if (this.searchRequest.length == 3) {
        method = 'ChooseModelYear'
        data = {
          productTypeId: this.productTypeId,
          modelId: this.searchRequest[1].value,
          modelYear: this.searchRequest[2].value,
        }
      } else {
        const variantSelectionData = []
        const keys = Object.keys(this.searchRequest)
        keys.forEach(key => {
          let type = this.searchRequest[key].type
          if (type == 'MakeId') {
            type = 'Make'
          } else if (type == 'ModelId') {
            type = 'Model'
          }
          variantSelectionData.push({
            Type: type,
            Value: this.searchRequest[key].value,
          })
        })

        method = 'NextStep'
        data = variantSelectionData

        // Scroll down to ad variant list
        const element = document.getElementById('PrivateAdVariantList')
        if (element == null) return
        element.scrollIntoView({ behavior: 'smooth', block: 'start' })
      }

      // AXIOS til server
      const timeoutId = setTimeout(() => {
        spinner.start()
      }, 100)
      // Clearing variantList before starting the call
      this.emitVariantList([])

      app.axios
        .post('/api/PrivateAd/' + method, JSON.stringify(data))
        .then(resp => {
          if (resp.data.length === 0) {
            // Der er sendt enten et tomt array eller et tomt objekt tilbage - der må være sket en fejl
            app.toast.error('Der er desværre sket en ukendt fejl.')
          } else {
            if (this.searchRequest.length == 1) {
              this.designationLists[1].items = resp.data
            } else if (this.searchRequest.length == 2) {
              this.designationLists[2].items = resp.data
            } else {
              if (Array.isArray(resp.data)) {
                this.emitVariantList(resp.data)
              } else {
                this.designationLists.push(resp.data)
              }
            }
          }

          // stop timeout if it hasn't run yet
          clearTimeout(timeoutId)

          spinner.stop()
        })
    },
  },
  created() {
    this.designationLists = JSON.parse(
      JSON.stringify(this.initialDesignationLists)
    )
    if (this.eventBus === null) return
    this.eventBus.on('private-ad-select-toggle', this.toggle)
    this.eventBus.on('private-ad-select-close', this.close)
    this.eventBus.on('private-ad-select-selection', this.handleSelection)
  },
}
</script>

<style lang="scss">
@import 'VehicleDesignation.scss';
</style>
